import { IEventAggregationService } from '@studyportals/event-aggregation-service-interface';
import { RenderCopilotService } from './utils/render-copilot-service';

declare global {
	interface Window {
		EventAggregationService: IEventAggregationService | null | undefined;
		rollbar?: typeof Rollbar;
		PostHog: import('posthog-js').PostHog;
		rollbarIgnore: (...args) => boolean;
	}
}

class Main {
	constructor() {
		this.createApplication();
	}

	private createApplication(): void {
		RenderCopilotService.renderCopilotApplication();
	}
}



const main = new Main();
export default main;

